export default "__VITE_ASSET__B6bM9Wi___"